import { CheckCircle2, XCircle, AlertTriangle, Loader2 } from "lucide-react"
import type { ViesValidation } from "../types"

interface ViesValidationBadgeProps {
  validation?: ViesValidation | null
  isValidating?: boolean
}

export function getViestooltipText(
  validation: ViesValidation | null | undefined
): string | null {
  if (!validation || validation.status === "skipped") return null

  const lines: string[] = []

  if (validation.status === "valid") {
    lines.push("VAT number is valid")
    if (validation.trader_name && validation.trader_name !== "---") {
      lines.push(validation.trader_name)
    }
    if (validation.trader_address && validation.trader_address !== "---") {
      lines.push(validation.trader_address)
    }
  } else if (validation.status === "invalid") {
    lines.push("VAT number is invalid")
  } else if (validation.status === "error") {
    lines.push("VAT verification failed")
    if (validation.error) {
      lines.push(validation.error)
    }
  }

  return lines.join("\n")
}

export function ViesValidationBadge({
  validation,
  isValidating,
}: ViesValidationBadgeProps) {
  if (isValidating) {
    return (
      <span className="flex items-center gap-1 flex-shrink-0">
        <Loader2 className="w-3.5 h-3.5 text-gray-400 animate-spin" />
        <span className="text-[10px] text-gray-400">Validating...</span>
      </span>
    )
  }

  if (!validation || validation.status === "skipped") {
    return null
  }

  if (validation.status === "valid") {
    return (
      <CheckCircle2
        className="w-4 h-4 text-green-500 flex-shrink-0"
        aria-label="VAT verified valid"
      />
    )
  }

  if (validation.status === "invalid") {
    return (
      <XCircle
        className="w-4 h-4 text-red-500 flex-shrink-0"
        aria-label="VAT verified invalid"
      />
    )
  }

  // status === "error"
  return (
    <AlertTriangle
      className="w-4 h-4 text-yellow-500 flex-shrink-0"
      aria-label="VAT verification failed"
    />
  )
}
